import type { RouteRecordRaw } from 'vue-router';

import ReportSubjectType from '@/features/report/report-page/models/ReportSubjectType';

const ReportPage = async () => import('@/pages/report/ReportPage.vue');
const ReportLeadsPage = async () => import('@/pages/report/ReportLeadsPage.vue');

const availableReportSubjectTypes: ReportSubjectType[] = [
  ReportSubjectType.CAMPAIGN,
  ReportSubjectType.OFFER,
  ReportSubjectType.LANDING,
  ReportSubjectType.AFFILIATE_NETWORK,
  ReportSubjectType.ROTATION,
  ReportSubjectType.TRAFFIC_SOURCE,
];

export default function getReportRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'report-leads',
      component: ReportLeadsPage,
      meta: {
        title: 'Report',
      },
      path: String.raw`/report/leads/:subjectType(${availableReportSubjectTypes.join('|')})/:subjectIds(\d+)+`,
    },
    {
      name: 'report',
      component: ReportPage,
      meta: {
        title: 'Report',
      },
      path: String.raw`/report/:subjectType(${availableReportSubjectTypes.join('|')})/:subjectIds(\d+)+`,
    },
  ];
}
